<template>
<div class="trend-page">
  <div class="head_area">
    <div class="leftImg">
      <img @click="back" src="/static/image/icon-jiantou@2x.eb0b501e01e95b720b727b63a23960e3.png" class="top_back">
    </div>
    <span class="head_text">{{ $t('单路区') }}</span>
    <span class="right_menu"></span>
  </div>
  <div class="table-box">
    <div class="table-head tr">
      <div class="td">{{ $t('期号') }}</div>
      <div class="td">{{ $t('值') }}</div>
      <div class="td">{{ $t('大') }}</div>
      <div class="td">{{ $t('小') }}</div>
      <div class="td">{{ $t('单') }}</div>
      <div class="td">{{ $t('双') }}</div>
      <div class="td">{{ $t('极大') }}</div>
      <div class="td">{{ $t('极小') }}</div>
      <div class="td">{{ $t('豹子') }}</div>
      <div class="td">{{ $t('对子') }}</div>
      <div class="td">{{ $t('顺子') }}</div>
    </div>
    <div class="table-tips tr">
      <div class="td">{{ $t('间隔') }}</div>
      <div class="td"></div>
      <div class="td">1</div>
      <div class="td">0</div>
      <div class="td">2</div>
      <div class="td">0</div>
      <div class="td">7</div>
      <div class="td">2</div>
      <div class="td">1</div>
      <div class="td">0</div>
      <div class="td">1</div>
    </div>
  </div>

  <div class="content">
    <van-list style="margin-top: 10px; padding-bottom: 120px" :finished-text="$t('没有更多了')" offset="300" v-model="loading" :finished="trend_list.length === trend_total_page" @load="getTrendList" v-if="trend_list.length > 0">

    <div class="table-box">
      <div class="table-content">
        <div class="tr" v-for="(item,index) in trend_list" :key="index">
          <div class="td">{{ item.sequencenum }}</div>
          <div class="td">{{item.outcome_arr[3]}}</div>
          <div class="td">
            <div class="red-bg btn" v-if="item.outcome_arr[3] >= 14">{{ $t('大') }}</div>
          </div>
          <div class="td">
            <div class="green-bg btn" v-if="item.outcome_arr[3] < 14">{{ $t('小') }}</div>
          </div>
          <div class="td">
            <div class="red-bg btn" v-if="item.outcome_arr[3] % 2 === 1">{{ $t('单') }}</div>
          </div>
          <div class="td">
            <div class="blue-bg btn small-size" v-if="item.outcome_arr[3] % 2 !== 1">{{ $t('双') }}</div>
          </div>
          <div class="td">
            <div class="red-bg btn small-size" v-if="item.outcome_arr[3] >= 22">{{ $t('极大') }}</div>
          </div>
          <div class="td">
            <div class="green-bg btn small-size" v-if="item.outcome_arr[3] <= 5">{{ $t('极小') }}</div>
          </div>
          <div class="td">
            <div class="blue-bg btn small-size" v-if="item.outcome_arr[0] === item.outcome_arr[1] && item.outcome_arr[1] === item.outcome_arr[2]">{{ $t('豹子') }}</div>
          </div>
          <div class="td">
            <div class="blue-bg btn small-size"
                 v-if="item.outcome_arr[0] === item.outcome_arr[1] || item.outcome_arr[1] === item.outcome_arr[2] || item.outcome_arr[0] === item.outcome_arr[2]"
            >{{ $t('对子') }}</div>
          </div>
          <div class="td">
            <div class="blue-bg btn small-size"
                 v-if="(item.outcome_arr[0] === (item.outcome_arr[1] - 1) && item.outcome_arr[1] === (item.outcome_arr[2] - 1)) || (item.outcome_arr[0] === 2 && item.outcome_arr[1] === 0 && item.outcome_arr[2] === 1) || (item.outcome_arr[0] === 7 && item.outcome_arr[1] === 6 && item.outcome_arr[2] === 5)"
            >{{ $t('顺子') }}</div>
          </div>
        </div>
      </div>
    </div>
    </van-list>
  </div>

</div>
</template>


<script>
import { translateText } from "../../common/utils"

export default {
  name: 'Trend',
  data() {
    return {
      page_size: 20,
      trend_page: 1,
      trend_total_page: 1,
      trend_list: [],
      loading: false
    }
  },
  mounted() {
    this.getTrendList()
  },
  methods: {
    async showTost(type, title) {
      const message = await translateText([title]);
      this.$parent.showTost(type, message[0]);
    },
    back(){
      window.history.go(-1)
    },
    getTrendList() {
      if (this.trend_page > this.trend_total_page) {
        this.loading = false;
        return;
      }
      this.$parent.showLoading()
      this.$apiFun
        .post('/api/game/trend', {
          type: 'jld28',
          per_page: this.page_size,
          page: this.trend_page
        })
        .then(async (res) => {
          if (res.code !== 200) {
            this.showTost(0, res.data.message);
          }
          if (res.code === 200) {
            const list = res.data.list
            this.trend_total_page = res.data.total_pages;
            list.forEach(item => {
              item.outcome_arr = item.outcome.split('-')
            })
            if(this.trend_page === 1) {
              this.trend_list = list
            }else {
              this.trend_list = [...this.trend_list, ...list]
            }
           this.trend_page++;
          }
          this.$parent.hideLoading();
          this.loading = false;
        })
        .catch(res => {
          this.$parent.hideLoading();
          this.loading = false;

        });
    },

  }
}
</script>
<style scoped lang="scss">
.trend-page {
  background: #000;
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  z-index: 1;
  overflow: hidden;
  bottom: 0;
  bottom: env(safe-area-inset-bottom, 0); /* 兼容刘海/手势栏 */
  display: flex;
  flex-direction: column;
  color: #fff;
  .head_area {
    position: relative;
    z-index: 2;
    height: 1.33333rem;
    display: flex;
    align-items: center;
    padding: 0 .4rem;
    .leftImg {
      flex: 1;
      text-align: right;
      transform: rotate(180deg);
    }
    .top_back {
      width: 0.26rem;
      height: 0.37333rem;
    }
    .head_text {
      font-size: 0.438rem;
      font-weight: bold;
      font-family: PingFang SC;
      color: #fff;
      width: 80%;
      text-align: center;
    }
    .right_menu {
      font-size: 0.37333rem;
      font-family: PingFang SC;
      color: #fff;
      flex: 1;
      text-align: right;
    }
  }
  .content {
    flex: 1;
    overflow: auto;
  }
  .table-box {
    .tr {
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 0.27rem;
      text-align: center;
      .td {
        width: 0.75rem;
        &:first-child {
          width: 1.5rem;
        }
      }
    }
    .table-head {
      background: #1E2223;
      height: 0.88rem;
      display: flex;
      align-items: center;
      padding: 0 .4rem;
      color: #8F9394;
    }
    .table-tips {
      padding: 0 .4rem;
      height: 1.01rem;
      display: flex;
      align-items: center;
      color: #A8D3FF;
      font-size: 0.32rem;
      .td:first-child {
        color: #fff;
      }
    }
    .table-content {
      padding: 0 .4rem;
      .tr {
        height: 1.07rem;
        display: flex;
        align-items: center;
        &:nth-child(odd) {
          background: #1E2223;
        }
        .btn {
          width: 0.55rem;
          height: 0.55rem;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          border: .02rem solid #000;
          font-size: .25rem;
        }
        .small-size {
          font-size: .21rem;
        }
        .green-bg {
          background: linear-gradient( 180deg, #00E137 0%, #00C400 47%, #00DC00 100%);
        }
        .red-bg {
          background: linear-gradient( 180deg, #FF5861 0%, #EC2627 47%, #FB3E38 100%);
        }
        .blue-bg {
          background: linear-gradient( 180deg, #99CFFF 0%, #7D9BFD 47%, #388BF6 100%);
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/game/trend.vue